import type { ReactNode } from 'react';

export function Cartao({
  titulo, desc, direita, children, classe
}: {
  titulo: ReactNode;
  desc?: ReactNode;
  direita?: ReactNode;
  children?: ReactNode;
  /** Classe extra (ex.: `p-card--destaque`). */
  classe?: string;
}) {
  return (
    <section className={classe ? `p-card ${classe}` : 'p-card'}>
      <div className="p-card__h">
        <div><h3>{titulo}</h3>{desc ? <p>{desc}</p> : null}</div>
        {direita}
      </div>
      {children}
    </section>
  );
}

export function Chave({ on, onClick }: { on: boolean; onClick(): void }) {
  return (
    <button type="button" className="p-sw" role="switch" aria-checked={on} onClick={onClick}><i /></button>
  );
}
